//index.js
import "./ConstellationPage.scss";
import React, { useState, useEffect } from "react";
import data from "../../data/videoPackage.json";
import Header from "../../components/ui/StickyHeader";
import Button from "../../components/ui/Button";
import TextBlock from "../../components/ui/TextBlock";
import LogoCard from "../../components/ui/LogoCard";
import Tile from "./PackageCard.js";
import mobileHeaderImage from "../../assets/Mobile_header.png";
import heroVideo from "../../assets/digitalProgram/hero-video.mp4";

const Constellation = () => {
	//for DealerPackagesSelector
	const [selectedCategory] = useState("No Package Selector");
	const [dataState, setDataState] = useState([]);

	useEffect(() => {
		if (data && data.packages && data.packages[selectedCategory]) {
			setDataState(data.packages[selectedCategory]);
		}
	}, [selectedCategory]);

	return (
		<>
			<Header
				logoBeforeScroll={require("../../assets/bmw_logo-allWhite.png")}
			/>
			<div style={{ backgroundColor: "black", paddingBottom: "100px" }}>
				{/* ------------ hero ------------ */}
				<div className="hero-container-wrapper">
					<div
						className="hero-container-constellation"
						style={{
							"--mobile-header-bg": `url(${mobileHeaderImage})`,
						}}>
						<video
							className="hero-background-video"
							autoPlay
							muted
							loop
							playsInline
							aria-hidden="true">
							<source src={heroVideo} type="video/mp4" />
						</video>
						<TextBlock
							hat=""
							title={
								<>
									The Ultimate Dealership
									<br />
									Story Starts Here
								</>
							}
							paragraph={
								<>
									Cinematic Tier-3 video production designed
									exclusively for
									<br />
									BMW Eastern Region dealers.
								</>
							}
							type="h1"
							color="white"
							align="center"
						/>
						<div className="button-container">
							<Button
								link="/enroll/package"
								styleName="blue"
								size="large">
								Enroll Now
							</Button>
						</div>
					</div>
				</div>
				<div className="constellation-container">
					{/* ------------ video production package ------------ */}
					<div
						className="dealer-packages-container"
						id="dealer-packages-anchor">
						<TextBlock
							title="Video Production Package"
							type="sectionHeader"
							align="center"
							fontWeight="500"
							classNames="constellation-section-header"
						/>
						<div className="powered-by-constellation-container">
							<TextBlock
								paragraph="Powered by"
								type="p-block"
								align="center"
								classNames="constellation-section-paragraph"
							/>
							<img
								src={require("../../assets/footerImgs/constellation.png")}
								alt="Constellation"
							/>
						</div>

						<div className="columns-container grid-container">
							<img
								src={require("../../assets/digitalProgram/package.png")}
								alt="Video Shoot grid"
								className="small-featured-image-quad"
							/>
							{Array.isArray(dataState) &&
							dataState.length > 0 ? (
								dataState.map((plan, index) => (
									<div className="column quad" key={index}>
										<Tile
											size="large"
											title={plan.title}
											description={plan.description}
											cost={plan.cost}
											pill={plan.pill}
											disclaimer={plan.disclaimer}
											listSpecs={plan.listSpecs}
											logos={plan.logos}
											cta={plan.cta}
										/>
									</div>
								))
							) : (
								<div>
									No data available for the selected category.
								</div>
							)}
						</div>
						<p
							className="disclaimer"
							style={{ textAlign: "center" }}>
							<span style={{ fontWeight: "bold" }}>
								*Enrollment Deadline February 28th
							</span>
						</p>
					</div>

					{/* ------------ program overview ------------ */}
					<div className="program-overview-container">
						<div className="columns-container">
							<div className="column">
								<TextBlock
									title="On-Site Dealership Production"
									paragraph="Professional filming of your team, showroom, model highlights, and dealership environment authentically captured for Tier-3 use."
									type="spec"
									color="white"
									align="left"
								/>
								<TextBlock
									title="Multi-Format Deliverables"
									paragraph="Every shoot delivers :30 & :15 landscape cutdowns plus :15 & :06 social versions ready for Meta, YouTube, and digital."
									type="spec"
									color="white"
									align="left"
								/>
							</div>

							<div className="column image-column">
								<div className="iphone-video-frame">
									<video
										src={require("../../assets/digitalProgram/BMW-BTS-NO-SUPERS-AUDIO.mp4")}
										className="vertical-image-iphone"
										autoPlay
										loop
										muted
										playsInline
									/>
									<img
										src={require("../../assets/digitalProgram/iphone.png")}
										alt=""
										className="iphone-frame"
										aria-hidden="true"
									/>
								</div>
							</div>

							<div className="column">
								<TextBlock
									title="Local Market Storytelling"
									paragraph="Curated local  footage and market-specific scripting bring your community into the story or go fully on-location."
									type="spec"
									color="white"
									align="left"
								/>
								<TextBlock
									title="Expandable Creative Options"
									paragraph="Every shoot captures ample b-roll and coverage, giving you a deep library of assets for expanded creative and ongoing rotation."
									type="spec"
									color="white"
									align="left"
								/>
							</div>
						</div>
					</div>
				</div>

				<div className="columns-container video-columns-container">
					<div className="column image-column">
						<video
							src={require("../../assets/digitalProgram/video1.mp4")}
							className="vertical-image"
							autoPlay
							loop
							muted
							playsInline
						/>
					</div>
					<div className="column image-column">
						<video
							src={require("../../assets/digitalProgram/video2.mp4")}
							className="vertical-image"
							autoPlay
							loop
							muted
							playsInline
						/>
					</div>
					<div className="column image-column">
						<video
							src={require("../../assets/digitalProgram/video3.mp4")}
							className="vertical-image"
							autoPlay
							loop
							muted
							playsInline
						/>
					</div>
				</div>

				<div className="constellation-container">
					{/* ------------ program packages ------------ */}
					<div className="program-packages-container">
						{/* ------------ program packages > how the program works ------------ */}
						<div className="how-program-works-top-container">
							<div className="columns-container ">
								<div className="column">
									<TextBlock
										title="How the Production Works"
										paragraph="Every Shot. Every Format. Delivered Ready to Run."
										type="sectionHeader"
										color="white"
										align="left"
									/>
								</div>
								<div className="column">
									<TextBlock
										paragraph="From arrival to final export, every production, is executed by an experienced crew focused on telling your dealership's story with precision."
										type="p-block"
										color="white"
										fontSize="20"
										fontWeight="300"
									/>
								</div>
							</div>
							<img
								src={require("../../assets/digitalProgram/how-production.png")}
								alt="BMW Car"
								className="small-featured-image"
							/>
						</div>

						<div className="how-program-works-tile-container">
							<div className="columns-container">
								<div className="column">
									<LogoCard
										styleName="vertical"
										size="small"
										alignment="left"
										backgroundImage={require("../../assets/digitalProgram/production1.png")}
										title="PRODUCTION PLANNING"
										description="Your dedicated production team coordinates all logistics, shot lists, and scheduling to maximize every minute on-site."
									/>
								</div>

								<div className="column">
									<LogoCard
										styleName="vertical"
										size="small"
										alignment="left"
										backgroundImage={require("../../assets/digitalProgram/production2.png")}
										title="ON-SITE EXECUTION"
										description="Up to 3 hours of professional filming capturing your dealership's exterior, showroom, models, team, and authentic customer moments."
									/>
								</div>
								<div className="column">
									<LogoCard
										styleName="vertical"
										size="small"
										alignment="left"
										backgroundImage={require("../../assets/digitalProgram/production3.png")}
										title="MULTI-FORMAT EDITING"
										description="Every video deliverable is cut and formatted for landscape broadcast, square social, and vertical placements. "
									/>
								</div>
								<div className="column">
									<LogoCard
										styleName="vertical"
										size="small"
										alignment="left"
										backgroundImage={require("../../assets/digitalProgram/production4.png")}
										title="RAW FOOTAGE"
										description="Receive all raw footage files alongside your finished assets, giving your team full creative flexibility for future use."
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="constellation-container-footer">
				<TextBlock
					title="READY TO BRING YOUR DEALERSHIP TO LIFE?"
					paragraph={
						<>
							Elevate your dealership with Tier-3 video production
							built for
							<br />
							the BMW Eastern Region.
						</>
					}
					type="sectionHeader"
					color="black"
					align="center"
				/>
				<div className="button-container">
					<Button
						link="/enroll/package"
						styleName="blue"
						size="large">
						Enroll Now
					</Button>
				</div>
				<TextBlock
					paragraph="*All productions scheduled on a rolling basis starting March 2026."
					type="disclaimer"
					color="black"
					align="center"
				/>
			</div>
		</>
	);
};

export default Constellation;
